export default {
  lift: {
    label: 'Y a-t-il un ascenseur ?',
  },
  lift_comment: {
    label: 'Quelle est la taille de l\'ascenseur ?',
    options: {
      small: 'Petit (1-2 pers)',
      middle: 'Moyen (3-4 pers)',
      big: 'Grand (5-6 pers)',
      veryBig: 'Très grand (>6 pers)',
    },
  },
};
